var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE8F60;}\n\t.st1{fill:#F8E07E;}\n\t.st2{fill:#F7EB98;}\n\t.st3{fill:#F9D261;}\n\t.st4{fill:#F8EED3;}\n\t.st5{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.31,185.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.01,151.26,61.62,185.55,104.31,185.55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.16,126.56c0.03,1.02,29.15,4.61,31.95,5.03c10.46,1.56,20.92,2.68,31.21,5c0.44,0.1,0.96,0.19,1.32-0.09 c0.37-0.28,0.42-0.82,0.43-1.28c0.23-9.5,0.28-18.99,0.29-28.49c0-1.72-0.07-3.61-1.25-4.86c-0.95-1.01-2.41-1.35-3.77-1.62 c-18.4-3.64-37.21-4.69-55.94-5.74c-0.97-0.05-2.12-0.03-2.69,0.76c-0.28,0.4-0.35,0.9-0.41,1.38 C57.15,106.57,56.76,116.58,57.16,126.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.69,95.67c1.73-1.85,4.05-3.01,6.33-4.12c5.03-2.47,10.06-4.94,15.09-7.42c2.26-1.11,4.56-2.23,7.06-2.54 c1.98-0.24,3.98,0.04,5.96,0.33c17.7,2.52,35.51,4.65,53.39,4.75c0.57,0,1.2,0.03,1.6,0.43c0.82,0.81,0,2.15-0.81,2.97 c-4.75,4.78-9.75,10.1-15.3,13.96c-4.14,2.88-6.68,2.01-10.55-0.46c-5.03-3.22-10.77-3.36-16.59-4.06 c-7.27-0.87-14.56-1.62-21.85-2.24c-4.1-0.35-8.21-0.66-12.32-0.92C68.93,96.22,59.74,94.55,58.69,95.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.52,100.02c-0.8,0.55-1.62,1.13-2.12,1.96c-0.66,1.09-0.67,2.44-0.65,3.71c0.03,3.15,0.06,6.3,0.09,9.45 c0.06,6.57,0.12,13.14,0.18,19.7c0.01,0.85,0.12,1.87,0.89,2.22c0.85,0.4,1.77-0.35,2.44-1.02c5.07-5.15,11.08-9.37,17.66-12.37 c3.44-1.57,7.42-3.19,8.76-6.73c0.59-1.56,0.56-3.29,0.52-4.96c-0.12-5.01-0.25-10.01-0.37-15.02c-0.08-3.34,1.37-10.7-2.91-10.36 c-3.99,0.31-9.09,3.66-12.49,5.62C131.36,94.59,127.43,97.31,123.52,100.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M128.39,98.96c-1.74,1.41-3.48,2.94-4.41,4.97c-0.65,1.44-0.86,3.03-1.05,4.6c-0.56,4.54-1.13,9.07-1.69,13.61 c-0.52-3.92-1.04-7.84-1.56-11.77c-0.27-2.05-0.68-4.34-2.38-5.52c-1.03-0.72-2.34-0.87-3.59-1.02 c-14.78-1.69-29.32-4.98-43.82-8.27c10.97,0.98,21.93,1.95,32.9,2.93c5.5,0.49,11.09,0.98,16.52,0c4.95-0.89,9.56-2.96,14.04-5.18 c4.46-2.21,9.14-4.12,13.55-6.36C140.31,89.42,133.82,94.56,128.39,98.96z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105,110.7c-0.02-1.45,0.6-2.9,1.67-3.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButter);
export default __webpack_public_path__ + "static/media/Butter.3d39ea00f938cd1d570ac7c4d1f22c0d.svg";
export { ForwardRef as ReactComponent };